import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import HowToBlock from 'components/_special/HowToBlock'
import SectionWrapper from 'components/SectionWrapper'
import { RU } from 'constants/countries'
import { LocalizationContext } from 'contexts/Localization'
import { Text } from 'styles/components/typography'

import TubeSpit from './components/TubeSpit'
import TubeSwab from './components/TubeSwab'

/**
 * DHowRegister
 *
 * @param {object} props - properties of component
 * @returns {node} DHowRegister
 */
const DHowRegister = ({ data, index, isSquareHidden, locale }) => {
  const { colors } = React.useContext(ThemeContext)
  const {
    paths: { shared },
  } = React.useContext(LocalizationContext)
  const imagesPath = `${shared}/dna_how/how_register_`

  return (
    <SectionWrapper
      isOverflowHidden={true}
      classNameInner="pb-4"
      classNameWrapper="bg--picton-blue"
    >
      <HowToBlock
        isSquareHidden={isSquareHidden}
        title={data.title}
        index={index}
        squareColor={colors.white}
        lineColor="light"
      >
        <div className="row">
          <div className="col-12 col-md-6 col-lg-5 offset-md-1 pb-2 pb-md-0">
            <Text
              className="text--white with-inverted-links"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
          </div>
          <div className="col-12 col-md-5 col-lg-6">
            {locale === RU ? (
              <TubeSwab path={imagesPath} />
            ) : (
              <TubeSpit path={imagesPath} />
            )}
          </div>
        </div>
      </HowToBlock>
    </SectionWrapper>
  )
}

DHowRegister.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  locale: PropTypes.string.isRequired,
  isSquareHidden: PropTypes.bool,
}

DHowRegister.defaultProps = {
  isSquareHidden: false,
}

export default DHowRegister
